import { FleekError } from './FleekError';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ProjectMembershipAlreadyExistErrorArgs = Record<string, any>;

export class ProjectMembershipAlreadyExistError extends FleekError<ProjectMembershipAlreadyExistErrorArgs> {
  public name = 'ProjectMembershipAlreadyExistError';

  toString = () => `Project membership already exists.`;
}
